// React
import React from "react";
// React
// CSS
import styles from "./ShopCard.module.css";
// CSS
// Models
import { I_ShopItem } from "../../../Models/interfaces";
// Models

type ShopCardProps = {
  data: I_ShopItem;
  onClick: () => void;
};

const ShopCard: React.FunctionComponent<ShopCardProps> = ({
  data: {
    download_able,
    gift_price,
    has_paid,
    id,
    image_url,
    price,
    title,
    lesson_id,
  },
  onClick,
}) => {
  return (
    <div
      className={`${styles.shopCardContainer}  flex flex-row items-center justify-between h-full  first-of-type:border-none mt-1 pb-2 pt-3`}
      onClick={onClick}
    >
      <div className={`${styles.left}`}>
        {has_paid ? (
          <></>
        ) : (
          <>
            <p>{price + gift_price}</p>
            <p>تومان</p>
          </>
        )}
      </div>
      <div
        className={`${styles.right} flex flex-row-reverse items-end justify-start h-full`}
      >
        <img
          src={image_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
          alt=""
          className="p-0.5 w-14 h-14 rounded-full"
        />
        <div
          className={`${styles.content} h-full flex flex-col justify-evenly items-end mr-4`}
        >
          <p className="text-sm text-right">{title}</p>
          <p className="text-xs">{download_able && "دانلودی"}</p>
        </div>
      </div>
    </div>
  );
};

export default ShopCard;
